import util from '../util'

let controller = 'SolicitacaoRelatorio'
export default {
  SolicitarRelatorioMovConta: function (dto) {
    return util.Axios.Post(controller + '/MovimentacaoPorConta', dto)
  },
  SolicitarRelatorioBoletosRegistrados: function (dto) {
    return util.Axios.Post(controller + '/BoletosRegistrados', dto)
  },
  SolicitarRelatorioExportacaoContabil: function (dto) {
    return util.Axios.Post(controller + '/ExportacaoContabil', dto)
  },
  SolicitarRelatorioExtrato: function (dto) {
    return util.Axios.Post(controller + '/RelatorioExtrato', dto)
  },
  SolicitarRelatorioSaldo: function (dto) {
    return util.Axios.Post(controller + '/Saldo', dto)
  },
  SolicitarRelatorioSaldoConsolidadoPorParceiro: function (dto) {
    return util.Axios.Post(controller + '/SaldoConsolidadoPorParceiro', dto)
  },
  SolicitarHistoricoLimiteAdicional: function (dto) {
    return util.Axios.Post(controller + '/LimiteAdicionalLogs', dto)
  },
  SolicitarHistoricoLimiteOperador: function (dto) {
    return util.Axios.Post(controller + '/LimiteOperadorLogs', dto)
  },
  SolicitarHistoricoLimiteAdicionalOperador: function (dto) {
    return util.Axios.Post(controller + '/LimiteAdicionalOperadorLogs', dto)
  },
  Listar: function (dto) {
    return util.Axios.GetAll(controller + '/ListarRelatorios', dto)
  },
  Download: function (id) {
    return util.Axios.GetBlob(controller + '/Download', id)
  },
  SolicitarRelatorioBACEN: function (dto) {
    return util.Axios.Post(controller + '/RelatorioBACEN', dto)
  },
  SolicitarRelatorioLimiteOperacao: function (dto) {
    return util.Axios.Post(controller + '/LimiteOperacaoLogs', dto)
  },
  SolicitarTodosOperadores: function (request) {
    return util.Axios.Post(controller + '/Operadores', request)
  },
  SolicitarRelatorioHistoricoFavorecido: function (dto){
    return util.Axios.Post(controller + '/HistoricoFavorecido', dto)
  },
  SolicitarSplit: function (dto) {
    return util.Axios.Post(controller + '/RelatorioSplit', dto)
  },
  SolicitarRelatorioTarifario: function (dto) {
    return util.Axios.Post(controller + "/Tarifario", dto)
  },
  SolicitarTarifaRecorrente: function (dto) {
    return util.Axios.Post(controller + '/TarifaRecorrente', dto)
  },
  SolicitarDDAPagadorEletronico: function (dto) {
    return util.Axios.Post(controller + '/DDAPagadorEletronico', dto)
  },
  SolicitarCessaoBoleto: function (dto) {
    return util.Axios.Post(controller + '/CessaoBoleto', dto)
  },
  SolicitarConsultaBoleto: function (dto) {
    return util.Axios.Post(controller + '/ConsultaBoleto', dto)
  }
}
